import React from 'react'; 
import PropTypes from 'prop-types'; 

import Image from '../Image'; 
import Button from '../Button';
import './style.scss';

function Point(props) {
  const { className, image, header, text, button, option } = props; 
  return (
    <div className={`point ${className}`}> 
      <Image src={image} alt="icon" /> 
      <h6>{header}</h6> 
      <p className="sub-segment-text">{text}</p>
      { button &&
          <Button src={button.link} value={button.text} option={option} /> 
      } 
    </div> 
  ); 
}

export default Point; 
